import { OAuthProvider } from 'firebase/auth';
import Provider from 'Classes/social-providers';
import IconOsSystemApple from 'Icons/bold/IconOsSystemApple';

export default new Provider({
  name: 'apple',
  icon: IconOsSystemApple,
  color: '#000000',

  getProviderInstance: () => new OAuthProvider('apple.com'),

  getLoginData: (data) => {
    // data.platform -> apple data (from app)
    // data._tokenResponse -> firebase data (from web)
    return data.platform ? {
      platform: data.platform,
      code: data.code, // == data._tokenResponse.oauthAccessToken
      email: data.user.email,
    } : {
      accessToken: data._tokenResponse.oauthAccessToken,
      idToken: data._tokenResponse.oauthIdToken,
      refreshToken: data._tokenResponse.refreshToken,
      email: data._tokenResponse.email,
      tokenType: 'Bearer',
    };
  },
  getUserData: (data) => {
    // data.user -> firebase user (from web)
    // data.additionalUserInfo -> apple user (from app)
    const firstName = data.user.displayName.split(' ')[0];
    const lastName = data.user.displayName.split(' ')[1];
    const email = data.user.email;
    const appleId = data.platform
      ? data.user.providerData.find(provider => provider.providerId === data.providerId).uid
      : data.additionalUserInfo.profile.sub;
    return {
      firstName,
      lastName,
      email,
      appleId,
    };
  },
});
